<template>
  <div class="connection-type-choice-popup">
    <popup :close-action="closeAction" :buttons="buttons" :or-between-buttons="true">
      <template v-slot:content>
        <div class="image">
          <lottie-player :src="JSON.stringify(require('@/assets/celebration/turnover.json'))" :autoplay="true" :loop="false"/>
        </div>
        <div class="title">
          יצאנו לדרך עם בנקאות פתוחה, אפשר לחבר חשבונות בחיבור ישיר!
        </div>
        <div class="subtitle">
          <span>בחיבור ישיר</span>
          <span class="bold">אפשר לתת לרייזאפ הסכמה לקריאת הנתונים בלי לתת סיסמה.</span>
          <span> ההסכמה תהיה בתוקף במשך שנה או עד שתבחרו לבטל אותה.</span>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>

import BaseUI from 'base-ui';
import Segment from '@/Segment';
import { mapActions, mapGetters } from 'vuex';
import AddCredentialsFlow
  from '@/pages/responsive-pages/authenticated/navigation-pages/credentials-settings/add-credentials-flow/AddCredentialsFlow';

export default {
  name: 'ConnectionTypeChoicePopup',
  components: {
    Popup: BaseUI.Popup,
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
    connectWithOBK: {
      type: Function,
      required: true,
    },
  },
  created() {
    Segment.trackUserGot('OBKMigrationConnectionTypeChoice_Entered', { sourceName: this.source.sourceName });
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('credentials', ['getCredsBankCCAccounts']),
    bankSourceWithBankCC() {
      return this.bankCCAccounts.length > 0;
    },
    bankCCAccounts() {
      return this.getCredsBankCCAccounts(this.source.credentialsId);
    },
    buttons() {
      return [{
        title: 'לחבר את החשבון בחיבור ישיר',
        size: 'slim',
        loading: this.loading,
        action: () => {
          Segment.trackUserGot('OBKMigrationConnectionTypeChoice_OBKClicked', { sourceName: this.source.sourceName });
          this.connectWithOBK();
        },
      }, {
        title: 'לעדכן סיסמה ולהישאר עם חיבור רגיל',
        size: 'slim',
        variant: 'secondary',
        action: () => {
          Segment.trackUserGot('OBKMigrationConnectionTypeChoice_RegularCredsClicked', { sourceName: this.source.sourceName });
          this.updateExistingCredentials();
        },
      }];
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    updateExistingCredentials() {
      this.openModal({
        component: AddCredentialsFlow,
        props: {
          sourceToUpdate: this.source,
          updateMode: true,
        },
        popupAlignment: 'full-screen',
      });
    },
    closeAction() {
      Segment.trackUserGot('OBKMigrationConnectionTypeChoice_CloseClicked', { sourceName: this.source.sourceName });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

  .connection-type-choice-popup {
    text-align: center;

    .image {
      padding: 20px;
      margin-bottom: 15px;
    }

    .title {
      font-size: 22px;
      text-align: center;
      font-weight: bold;
    }

    .subtitle {
      font-size: 16px;
      text-align: center;
      margin-bottom: 15px;
      line-height: 22px;
    }

    .bold {
      font-weight: bold;
    }

    ::v-deep .riseup-button.slim .button-titles .button-title {
      font-size: 16px;
    }

    ::v-deep .riseup-button .button-content{
      padding: 0 10px;
    }
  }

</style>
